export const useTime = (time: string) => {
        if (time) {
          const [hourString, minute] = time?.split(":");
          const hour = +hourString % 24;
          return (hour % 12 || 12) + ":" + minute + (hour < 12 ? " AM" : " PM");
        } else return "";
  };